/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimpleInteger
 */
export interface SimpleInteger {
    /**
     * 
     * @type {number}
     * @memberof SimpleInteger
     */
    value: number;
}

/**
 * Check if a given object implements the SimpleInteger interface.
 */
export function instanceOfSimpleInteger(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function SimpleIntegerFromJSON(json: any): SimpleInteger {
    return SimpleIntegerFromJSONTyped(json, false);
}

export function SimpleIntegerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleInteger {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function SimpleIntegerToJSON(value?: SimpleInteger | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

